import { pluralRu } from '@/utils/russianPlural';

function unreadMessageForms(count: number): { adj: string; noun: string } {
  return {
    adj: pluralRu(count, { one: 'новое', few: 'новых', many: 'новых' }),
    noun: pluralRu(count, { one: 'сообщение', few: 'сообщения', many: 'сообщений' }),
  };
}

/** «новое сообщение», «новых сообщения», «новых сообщений» — без числа (число в бейдже). */
export function formatUnreadOverlayMessageSuffix(count: number): string {
  const { adj, noun } = unreadMessageForms(count);
  return `${adj} ${noun}`;
}

/** Полная строка для aria-label: «У вас 1 новое сообщение». */
export function formatUnreadOverlayMessage(count: number): string {
  const { adj, noun } = unreadMessageForms(count);
  return `У вас ${count} ${adj} ${noun}`;
}
